import PropTypes from 'prop-types';

import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
  DialogTitle
} from '@mui/material';

import {
  CheckCircleOutlined,
  Close,
  PersonOutlined
} from '@mui/icons-material';

import { workflowFallback, workflowSteps } from './WorkflowTimelineModalData';

import {
  completedIconSx, dialogPaperSx,
  getStepContentSx, personIconSx,
  stepContentBoxSx,
  stepContentTextSx,
  stepMetaSx,
  stepperSx,
  stepUserSx
} from '../../Common/components/Styles/CommunicationDialogStyles';
import {
  dialogHeaderStyles,
  patientNameSx,
  patientMrSx,
  patientBoxSx
} from '../../Common/components/Styles/InputStyles';

const WorkflowTimelineModal = ({ open, onClose, data }) => {
  const patientData = {
    ...workflowFallback,
    ...data
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: dialogPaperSx
        }
      }}>
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>
            {' '}
            Workflow Timeline
          </Typography>

          <Typography sx={dialogHeaderStyles.subtitle}>
            {' '}
            Track key events and communications
          </Typography>
        </Box>

        <IconButton
          aria-label="Close create issue dialog"
          onClick={onClose}
          size="small"
          sx={dialogHeaderStyles.dialogheaderclose}>
          <Close sx={{ fontSize: 22 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2, my: 2 }}>
        <Box sx={patientBoxSx}>
          <Typography sx={patientNameSx}>{patientData.patient}</Typography>

          <Typography sx={patientMrSx}>MR# {patientData.mrNumber}</Typography>
        </Box>

        <Stepper
          activeStep={workflowSteps.length}
          orientation="vertical"
          connector={null}
          sx={stepperSx}>
          {workflowSteps.map((step, index) => {
            const isLastStep = index === workflowSteps.length - 1;

            return (
              <Step key={step.id} expanded completed>
                <StepLabel icon={<CheckCircleOutlined sx={completedIconSx} />}>
                  {step.label}
                </StepLabel>

                <StepContent sx={getStepContentSx(isLastStep)}>
                  <Typography sx={stepMetaSx}>
                    {step.description}
                    {' \u2022 '}
                    {step.dateTime}
                  </Typography>

                  <Typography sx={stepUserSx}>
                    <PersonOutlined sx={personIconSx} />

                    {step.user}
                  </Typography>

                  <Box sx={stepContentBoxSx}>
                    {step.content.map(item => (
                      <Typography key={item} sx={stepContentTextSx}>
                        {item}
                      </Typography>
                    ))}
                  </Box>
                </StepContent>
              </Step>
            );
          })}
        </Stepper>
      </DialogContent>
    </Dialog>
  );
};

WorkflowTimelineModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    patient: PropTypes.string,
    mrNumber: PropTypes.string
  })
};

WorkflowTimelineModal.defaultProps = {
  data: null
};

export default WorkflowTimelineModal;
